import {
    trigger,
    transition,
    style,
    query,
    group,
    animateChild,
    animate,
    keyframes,
    state,
    AnimationTriggerMetadata,
} from '@angular/animations';
export const fader =
trigger( 'routeAnimations',[
    state('*', style({
        transition: '1000ms ease', // use interpolation
    }), {params: {time: 1000}}), 
    transition( '* <=> *', [
        style({ overflow: 'hidden' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                left: 0,
                width: '100%',
                visibility: 'hidden',
                opacity: 0,
                height:'100%',
                
            }),
        ] ,{ optional : true }),
        query(':enter' ,[
            state('*', style({
                transition: '1000ms ease', 
                visibility: 'visible' ,
                height:'100%',
                opacity: 1,// use interpolation
            }), {params: {time: 1000}}), 
        ] ,{ optional : true }),
        
    ]),
])
export const opacity =
trigger( 'opacity',[
    transition( '* <=> *', [
        style({overflow: 'hidden',}),
        query(':enter, :leave' , [
            style({
                position: 'absolute',
                opacity: 0,
            }),
        ],{ optional : true }),
        query(':enter' ,[
            animate('250ms ease' , 
                style({
                    position: 'absolute',
                    opacity: 1,})
            )
        ],{ optional : true })
    ]),
])

export const fadePost =
trigger( 'fadePost',[
    transition( '* <=> *', [
        query(':enter, :leave' , [
            style({
                opacity: 0,
            }),
        ],{ optional : true }),
        query(':enter' ,[
            animate(`400ms ease` , 
                style({
                    opacity: 1,})
            )
        ],{ optional : true })
    ]),
])

export const slide =
trigger('slideInOut', [
    transition(':enter', [
    style({transform: 'translateY(-100%)',opacity:0}),
    animate('250ms ease-in', style({transform: 'translateY(0%)',opacity:1}))
    ]),
    transition(':leave', [
    style({transform: 'translateY(0%)',opacity:1}),
    animate('250ms ease-in', style({transform: 'translateY(-100%)',opacity:1}))
    ])
])
export const categorizedPosts: AnimationTriggerMetadata = trigger('categorizedPosts', [
transition('done => entering', [
    style({
        'margin-left': '90%'
    }),
    animate('200ms ease',
        style({ 'margin-left': '*' }))
    ]),
]);

export const navigateAnimation =
trigger( 'navigateAnimation',[
    transition( '* <=> *', [
        style({ overflow: 'hidden' }),
        query(':enter, :leave' , [
            style({
                position: 'absolute',
                left: 0,
                width: '100%',
                visibility: 'hidden',
                opacity: 0,
                height:'100%',
                
            }),
        ] ,{ optional : true }),
        query(':enter' ,[
            animate('500ms ease' , 
                style({
                    visibility: 'visible' ,
                    height:'100%',
                    opacity: 1,
                    })
            )
        ] ,{ optional : true })
    ] ),
])
export const fade = trigger('fade', [
    transition(':enter', [
      style({ opacity:0 }),
      animate('0.3s ease-in', style({ opacity: 1 }))
    ])
])

export const expandCollapse = trigger('expandCollapse', [
    state('collapsed', style({ height: '0px', overflow: 'hidden' })),
    state('expanded', style({ height: '*' })),
    transition('collapsed => expanded', animate('300ms ease-out')),
    transition('expanded => collapsed', animate('300ms ease-in'))
])


export const slideAnimation = trigger('slideAnimation', [
    state('false', style({ display: 'none'})),
    state('true', style({ display: 'block'})),
    transition('false => true', [
      style({ transform: 'translateX(350px)' }),
      animate('0s 0s', style({ display: 'block' })),
      animate('0.4s 0.25s ease-out', style({ transform: 'translateX(0%)' })),
    ]),
    transition('true => false', [
      animate('0.4s ease-in', style({ transform: 'translateX(350px)' })),
      animate('0s 0.65s', style({ display: 'none' })),
    ]),
]);

export const conditionBaseSlideAnimation = trigger('conditionBaseSlideAnimation', [
    transition('false => true', [
      style({ transform: 'translateX(310px)' }),
      animate('0.4s 0.25s ease-out', style({ transform: 'translateX(0%)' })),
    ]),
    transition('true => false', [
      animate('0.4s ease-in', style({ transform: 'translateX(310px)' })),
    ]),
]);